import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../_metronic/layout/core';
import {
  TachoOrderForm,
  TachoOrderFormValues,
  getTachoOrder,
} from '../../modules/tacho-orders';

const TachoOrderEditPage: FC = () => {
  const intl = useIntl();
  const { id } = useParams<{ id: string }>();
  const [initialValues, setInitialValues] = useState<
    TachoOrderFormValues | undefined
  >();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchOrder() {
      try {
        const { data } = await getTachoOrder(Number(id));
        setInitialValues({
          number: data.number || '',
          date: data.date || '',
          email: data.email || '',
          shipping_name: data.shipping_address?.name || '',
          shipping_street: data.shipping_address?.street || '',
          shipping_city: data.shipping_address?.city || '',
          shipping_postcode: data.shipping_address?.postcode || '',
          shipping_country: '',
          shipping_phone: data.shipping_address?.phone || '',
        });
      } catch (error) {
        console.warn(error);
      } finally {
        setLoading(false);
      }
    }
    fetchOrder();
  }, [id]);

  return (
    <>
      <PageTitle>
        {intl.formatMessage({ id: 'tachoOrders.editTitle' })}
      </PageTitle>
      {loading ? (
        <div className="card p-10">
          <div className="spinner-border text-primary" role="status" />
        </div>
      ) : (
        <TachoOrderForm
          mode="edit"
          orderId={Number(id)}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export { TachoOrderEditPage };
